export default __webpack_public_path__ + "static/media/JAMESABADI-Clarity_Slime-0.5ETHM.32c71af3.mp4";